import { useUser } from 'vl-core/hooks/useUser';
import { z } from 'zod';

const UserTypeSchema = z.union([
  z.literal('REFERRER'),
  z.literal('CLIENTADMIN'),
  z.literal('ADMIN'),
  z.literal('PATIENT'),
  z.literal('CLINICIAN')
]);

export type UserType = 'REFERRER' | 'CLIENTADMIN' | 'ADMIN' | 'PATIENT' | 'CLINICIAN';

/** Returns the user type of the current user, or `null` if the user’s type is not
one of `REFERRER`, `CLIENTADMIN`, `ADMIN`, `PATIENT`, or `CLINICIAN`. */
export function useUserType() {
  const { user_type_code } = useUser() || {};

  try {
    return UserTypeSchema.parse(user_type_code);
  } catch {
    console.error('useUserType', 'Unexpected user type: ', user_type_code);
    return null;
  }
}

export default useUserType;
